var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "writer",
    staticClass: "writer contents",
    attrs: {
      "data-editor-active": ""
    }
  }, [_c('h3', {
    ref: "title",
    staticClass: "title",
    attrs: {
      "data-grid-layout": "title"
    }
  }, [_vm._v(" " + _vm._s(this.titleText) + " ")]), _c('div', {
    attrs: {
      "data-grid-layout": "tl"
    }
  }), _c('table', {
    staticClass: "writer",
    attrs: {
      "data-grid-layout": "content"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("이름")]), _c('td', [_vm._v(_vm._s(_vm.userInfo.name))]), _c('th', [_vm._v("이메일")]), !_vm.readonly ? _c('td', [_vm._v(_vm._s(_vm.userInfo.email))]) : _c('td', [_vm._v(_vm._s(_vm.optionInfo.emailActive ? _vm.userInfo.email : `(비공개)`))])]), _c('tr', [_c('th', [_vm._v("소속(직장명)")]), !_vm.readonly ? _c('td', [_vm._v(_vm._s(_vm.userInfo.companyName))]) : _c('td', [_vm._v(_vm._s(_vm.optionInfo.companyNameActive ? _vm.userInfo.companyName : `(비공개)`))]), _c('th', [_vm._v("전화번호")]), !_vm.readonly ? _c('td', [_vm._v(_vm._s(_vm.userInfo.mobile))]) : _c('td', [_vm._v(_vm._s(_vm.optionInfo.mobileActive ? _vm.userInfo.mobile : `(비공개)`))])]), _c('tr', [_c('th', [_vm._v("직책")]), !_vm.readonly ? _c('td', [_vm._v(_vm._s(_vm.userInfo.position))]) : _c('td', [_vm._v(_vm._s(_vm.optionInfo.positionActive ? _vm.userInfo.position : `(비공개)`))]), _c('th', [_vm._v("연구분야")]), !_vm.readonly ? _c('td', [_vm._v(_vm._s(_vm.userInfo.researchPart))]) : _c('td', [_vm._v(_vm._s(_vm.optionInfo.researchPartActive ? _vm.userInfo.researchPart : `(비공개)`))])]), _c('tr', [_c('th', [_vm._v("연구자번호")]), _c('td', [_vm._v(_vm._s(_vm.optionInfo.researchNumberActive ? _vm.userInfo.researchNumber : `(비공개)`))]), _c('th', [_vm._v("-")]), _c('td')])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }